import { Component, Input } from '@angular/core';
import { IUnifiedBackgroundCheckDetail } from '../../../../core/interfaces/unified-background-check.interface';
import { IReportDetails } from '../../driver-background-check.view-models';
import { classColor as resolveClassColor } from '../../driver-background-check.constants';

@Component({
  selector: 'app-bgc-status-bar',
  templateUrl: './bgc-status-bar.component.html',
  styleUrls: ['./bgc-status-bar.component.scss', '../../driver-background-check.component.scss']
})
export class BgcStatusBarComponent {
  @Input() detail: IUnifiedBackgroundCheckDetail;
  @Input() reportDetails: IReportDetails;
  @Input() turnaroundTime: string;
  @Input() inactiveTooltip: string;

  classColor(value: string): string {
    return resolveClassColor(value);
  }

  isGoodOutcome(value: string): boolean {
    if (!value) {
      return false;
    }
    const normalized = value.trim().toUpperCase();
    return normalized === 'CLEAR' || normalized === 'ELIGIBLE';
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-status-bar/bgc-status-bar.component.ts